import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Color from 'color';
import styled from 'styled-components';
import useInheritedTheme from '../../Hooks//UseInheritedTheme';
export default function ThemeToggle(props) {
    const theme = useInheritedTheme();
    const primary = new Color(theme.primary);
    const secondary = new Color(theme.secondary);
    const isDark = primary.luminosity() < secondary.luminosity();
    return (_jsx(Container, { className: props.className, onClick: props.onClick, children: _jsxs("div", { className: `wmapp-switch ${isDark ? 'dark' : ''}`, children: [_jsxs("div", { className: "wmapp-switch-switch", children: [_jsxs("svg", { className: "stars", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", id: "Layer_1", x: "0px", y: "0px", viewBox: "0 0 18 12", xmlSpace: "preserve", children: [_jsx("path", { className: "st0", d: "M6.1,0.2c-0.3-0.3-1-0.2-2,0.4c-0.3-0.1-0.6-0.2-1-0.2c-1.5,0-2.7,1.2-2.7,2.7c0,0.3,0.1,0.7,0.2,1  c-0.7,1-0.8,1.6-0.5,2c0.1,0.1,0.3,0.2,0.5,0.2c0.3,0,0.7-0.2,1.2-0.5C2,5.7,2.1,5.7,2.2,5.6c0.3,0.1,0.6,0.2,0.9,0.2  c1.5,0,2.7-1.2,2.7-2.7c0-0.3-0.1-0.6-0.2-0.9C5.7,2.1,5.7,2,5.8,1.9C6.3,1.1,6.4,0.5,6.1,0.2z M3.1,1.2c0.7,0,1.3,0.4,1.6,0.9  C4.4,2.5,4,3,3.5,3.5C3,4,2.5,4.4,2.1,4.7C1.6,4.4,1.2,3.8,1.2,3.1C1.2,2,2.1,1.2,3.1,1.2z M0.7,5.5c0-0.1,0.1-0.4,0.3-0.7  c0.1,0.1,0.3,0.3,0.4,0.4C1.1,5.4,0.9,5.5,0.7,5.5z M5,3.1C5,4.2,4.2,5,3.1,5C3.1,5,3,5,3,5C3.3,4.7,3.7,4.4,4,4  c0.4-0.4,0.7-0.7,1-1.1C5,3,5,3,5,3.1z M4.8,1.1c0.3-0.2,0.6-0.3,0.7-0.3c0,0.1-0.1,0.4-0.3,0.7C5.1,1.3,5,1.2,4.8,1.1z" }), _jsx("g", { children: _jsx("path", { className: "st0", d: "M12.9,12c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.2-0.3-0.2-0.4l0.3-1.8l-1.3-1.3c-0.1-0.1-0.2-0.3-0.1-0.4   c0-0.2,0.2-0.3,0.3-0.3l1.8-0.3l0.8-1.6c0.1-0.3,0.6-0.3,0.8,0l0.8,1.6l1.8,0.3c0.2,0,0.3,0.1,0.3,0.3c0,0.2,0,0.3-0.1,0.4   l-1.3,1.3l0.3,1.8c0,0.2,0,0.3-0.2,0.4c-0.1,0.1-0.3,0.1-0.4,0l-1.6-0.8L13.1,12C13,12,12.9,12,12.9,12z M14.7,10.2   c0.1,0,0.1,0,0.2,0l1,0.5l-0.2-1.2c0-0.1,0-0.3,0.1-0.4l0.8-0.8l-1.2-0.2c-0.1,0-0.3-0.1-0.3-0.2L14.7,7l-0.5,1.1   c-0.1,0.1-0.2,0.2-0.3,0.2l-1.2,0.2l0.8,0.8c0.1,0.1,0.1,0.2,0.1,0.4l-0.2,1.2l1-0.5C14.5,10.2,14.6,10.2,14.7,10.2z" }) })] }), _jsxs("svg", { className: "clouds", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", id: "Layer_1", x: "0px", y: "0px", viewBox: "0 0 20 12", xmlSpace: "preserve", children: [_jsx("path", { className: "st0", d: "M16.9,2.2h1c1.1,0,2.1,0.9,2.1,2.1v0c0,1.1-0.9,2.1-2.1,2.1h-4c-1.7,0-3.2-1.4-3.2-3.2S12.2,0,13.9,0  C15.3,0,16.5,0.9,16.9,2.2z" }), _jsx("path", { className: "st0", d: "M5.5,8.3h0.9c1,0,1.9,0.8,1.9,1.9v0c0,1-0.8,1.9-1.9,1.9H2.8C1.3,12,0,10.7,0,9.2s1.3-2.8,2.8-2.8  C4.1,6.3,5.2,7.2,5.5,8.3z" })] })] }), _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", id: "Layer_1", x: "0px", y: "0px", viewBox: "0 0 10 10", className: "sun", xmlSpace: "preserve", children: _jsx("circle", { className: "st0", cx: "5", cy: "5", r: "5" }) }), _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", version: "1.1", id: "Layer_1", x: "0px", y: "0px", viewBox: "0 0 10 10", className: "moon", xmlSpace: "preserve", children: _jsx("path", { className: "st0", d: "M3,5c0-2.2,1.5-4.1,3.5-4.7C6,0.1,5.5,0,5,0C2.2,0,0,2.2,0,5s2.2,5,5,5c0.5,0,1-0.1,1.5-0.3C4.5,9.1,3,7.2,3,5z  " }) })] }) }));
}
const Container = styled.div `
	border-radius: 20px;
	overflow: hidden;
	max-height: 30px;
	max-width: 66px;

	.wmapp-switch {
		width: auto;
		margin: 0;
		padding: 0;
		position: relative;

		.sun,
		.moon {
			pointer-events: none;
			display: block;
			position: absolute;
			border: none;
			width: 24px;
			height: 24px;
			transform: translate3d(0, 0, 0) rotate(0);
			transition:
				transform 0.6s cubic-bezier(0, 0, 0.44, 0.96) 0s,
				opacity 0.6s cubic-bezier(0, 0, 0.44, 0.96) 0s;
			top: 3px;
			left: 3px;
		}

		.sun {
			opacity: 1;

			.st0 {
				fill: #fba441;
			}
		}

		.moon {
			opacity: 0;

			.st0 {
				fill: #f4dc3e;
			}
		}

		.wmapp-switch-switch {
			width: 66px;
			height: 30px;
			margin: 0;
			border: 0;
			background: #b7e3ff;
			overflow: hidden;
			transition: all 0.3s cubic-bezier(0, 0, 0.44, 0.96) 0s;

			.stars,
			.clouds {
				display: block;
				height: 24px;
				position: absolute;
				bottom: 3px;
				border: none;
				border-radius: 0;
				transition: all 0.6s cubic-bezier(0, 0, 0.44, 0.96) 0.1s;
			}

			.clouds {
				width: 26px;
				background-size: 26px;
				right: 7px;
				opacity: 1;

				.st0 {
					fill: #ffffff;
				}
			}

			.stars {
				width: 39px;
				background-size: 30px;
				right: 70px;
				opacity: 0;

				.st0 {
					fill: #f4dd3f;
				}
			}
		}

		&.dark {
			.sun {
				transform: translate3d(36px, 0, 0) rotate(180deg);
				opacity: 0;
			}

			.moon {
				transform: translate3d(36px, 0, 0) rotate(180deg);
				opacity: 1;
			}

			.wmapp-switch-switch {
				background: #000;

				.clouds {
					right: -6px;
					opacity: 0;
				}

				.stars {
					right: 20px;
					opacity: 1;
				}
			}
		}
	}

	&:hover {
		cursor: pointer;
	}
`;
//# sourceMappingURL=ThemeToggle.js.map